import React, { Component } from 'react';
import { connect } from 'react-redux';
import { importPOTemplate } from 'actions/EntityActions';
import ConfirmPODialog from './ConfirmPODialog';
import moment from 'moment';
import { Button } from '@mui/material';
import { showError } from 'actions/CommonActions';
import { readExcel } from 'utils/helpers';

class ExcelUploadAccessoryPO extends Component {
    constructor(props) {
        super(props);

        this.state = {
            confirmDialog: false,
            totalPriceMatch: false,
            POName: '',
            model: {}
        };
    }

    callback = (model) => {
        let subtotal = 0;
        model.Products.map(item => { subtotal += item.Quantity * item.UnitCostPrice; });
        const today = new Date();
        this.props.purchaseOrderList.map(item => { if (item.subTotal != 0 && item.subTotal - subtotal < 0.2 && item.subTotal - subtotal > -0.2 && moment(today).diff(moment(item.creationDate), 'days') < 4) this.setState({ totalPriceMatch: true, POName: item.description }) });
        this.setState({ model: model, confirmDialog: true });
    }

    uploadFile = (e, callback) => {
        e.preventDefault();
        let BranchId = this.props.branchId;
        let that = this;
        readExcel(e.target.files[0]).then((data) => {
            try {
                let productArray = [];
                if (data.length > 0) {
                    if (data[0]["SKU"] != "TECHPOS PO IMPORT TEMPLATE") {
                        that.props.showError("Wrong template used! Please download the latest version of template and try again!");
                        return;
                    }

                    //shipping fee
                    let ShippingCost = data[2]["TotalQuantity"] ? Number(data[2]["TotalQuantity"].toString().replace('$', '')) : 0;
                    //credits
                    let Credits = data[2]["ProductName(Optional)"] ? Number(data[2]["ProductName(Optional)"].toString().replace('$', '')) : 0;
                    //vendor name
                    let VendorName = data[3]["TotalQuantity"];

                    if ((!VendorName)) {
                        this.props.showError("VendorName can't be empty!");
                        return;
                    }

                    //invoice name
                    let InvoiceName = data[4]["TotalQuantity"];
                    //pst
                    let PST = data[5]["TotalQuantity"] ? Number(data[5]["TotalQuantity"].toString().replace('$', '')) : 0;
                    //gst
                    let GST = data[6]["TotalQuantity"] ? Number(data[6]["TotalQuantity"].toString().replace('$', '')) : 0;
                    //hst
                    let HST = data[7]["TotalQuantity"] ? Number(data[7]["TotalQuantity"].toString().replace('$', '')) : 0;
                    
                    for (let i = 9; i < data.length; i++) {
                        let item = data[i];
                        let SKU = item["SKU"];
                        let ProductName = item["ProductName(Optional)"];
                        let quantity = item["TotalQuantity"];
                        let unitCostPrice = item["UnitCostPrice"] ? item["UnitCostPrice"].toString().replace('$', '') : '';
                        let SalesPrice = item["UnitSalesPrice(Optional)"] ? item["UnitSalesPrice(Optional)"].toString().replace('$', '') : '';
                        let UPC = item["UPC(Optional)"];
                        let CategoryName = item["CategoryName(Optional)"];
                        let Brand = item["Brand(Optional)"];
                        let Description = item["Description(Optional)"];

                        if ((SKU === "" || SKU == undefined || SKU == null) && (ProductName === "" || ProductName == undefined || ProductName == null)) {
                            that.props.showError("SKU or Product Name can't be empty! Please check line " + (i + 5));
                            return;
                        }

                        if (SKU.length >= 50) {
                            that.props.showError("SKU length can't be over 50 characters! Please check line " + (i + 5));
                            return;
                        }

                        if ((isNaN(quantity) || Number(quantity) <= 0) || (isNaN(unitCostPrice) || Number(unitCostPrice) <= 0)) {
                            that.props.showError(`Format issue detected for SKU:${SKU}. Please make sure no comma exists and trim all the cells in the file imported.`);
                            return;
                        }

                        let model = {
                            SKU,
                            Quantity: Number(quantity),
                            UnitCostPrice: Number(unitCostPrice),
                            SalesPrice: Number(SalesPrice),
                            UPC,
                            ProductName,
                            CategoryName,
                            Brand,
                            Description
                        };

                        productArray.push(model);
                    }

                    let model = {
                        BranchId,
                        VendorName,
                        ShippingCost,
                        PST,
                        GST,
                        HST,
                        Credits,
                        InvoiceName,
                        Products: productArray
                    }

                    callback(model);
                } else {
                    this.props.showError("No data found in PO file, please make sure you upload the PO file with excel format.");
                    return;
                }
            } catch (error) {
                console.log(error);
                this.props.showError("PO Import fail, please do a hard refresh, check and remove the extra line in the file then try importing again.");
                return;
            }
        });
    }

    closeDialog = () => {
        this.setState({ confirmDialog: false });
        this.setState({ totalPriceMatch: false, POName: "", model: {} });
    }

    createPO = () => {
        this.props.importPOTemplate(this.state.model);
        this.closeDialog();
    }

    render() {
        const styles = {
            uploadButton: this.props.buttonStyles,
            uploadInput: {
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: '2px',
                left: 0,
                width: '100%',
                opacity: 0
            }
        };
        return (
            <span>
                <Button
                    component="span"
                    style={styles.uploadButton}
                    variant="contained"
                    id="importFromAccessoryTemplate"
                    className={this.props.className}
                >
                    Import FROM ACCESSORIES TEMPLATE
                    <input className="fileInput"
                        type="file"
                        id="inputImportAccessoryTemplate"
                        style={styles.uploadInput}
                        onChange={(e) => this.uploadFile(e, this.callback)}
                        onClick={(e) => e.target.value = null} />

                    <ConfirmPODialog
                        branchName={this.props.branchName}
                        totalPriceMatch={this.state.totalPriceMatch}
                        POName={this.state.POName}
                        model={this.state.model}
                        confirmDialog={this.state.confirmDialog}
                        closeDialog={this.closeDialog}
                        createPO={this.createPO} />
                </Button>
            </span>

        );
    }
}

function mapStatetoProps(state) {
    return {
        branchId: state.common.branchId,
        province: state.common.store.provinceState,
        branchName: state.common.store.name || '',
        purchaseOrderList: state.entity.purchaseOrderList || []
    };
}

function mapDispatchToProps(dispatch) {
    return {
        importPOTemplate: (model) => dispatch(importPOTemplate(model)),
        showError: (message) => dispatch(showError(message))
    }
}

export default connect(mapStatetoProps, mapDispatchToProps)(ExcelUploadAccessoryPO);